export { default } from './ProfileAvatar';
export { default as template } from './profile-avatar.tpl';
